export default __webpack_public_path__ + "static/media/poster9.76362c9e.png";